import React, { useMemo } from 'react';
import ToggleButton from '../ToggleButton/ToggleButton';
import { aboutFields } from './displayFields';
const SimpleReactSelect = React.lazy(() => import('@formElements/SimpleReactSelect/indexCopy'));
import { LABEL } from '../../../veriables';
import cn from 'classnames';
import style from './optionMenuCopy.module.scss';
import { TouchableDiv, TouchableButton } from '../Touchable/index';
import FullWidthModal from '../Modal/FullWidthModal';
import ModalHeader from '../ModalHeader';
const OptionComp = (props) => {

  // Props Destructuring
  const {
     handleChangeJob, isChangeJob, setIsChangeJob, dropDownRef, setDefaultValue, setErrors, optionForDropdown, handleChange, defaultValue, errors, orientation, setOrientation, setIsOrientationChange, isOrientationChange, handleOrientationChangeSave,
    handleCashOut, auth, aboutData, serverAppTheme, setAboutTipShow, isAboutShow, setTipShow, serverAppNavigationMenu, emptyDeviceGroup, orderingPortraitOrientation
  } = props;

  const onChangeJobClick = () => {
    handleChangeJob();
    setAboutTipShow(false);
  };
  
  const onAboutClick = () => {
    setAboutTipShow(true);
    setTipShow(false);
    setIsChangeJob(false);
  };

  const btnStyle = useMemo(() => ({
    background: serverAppTheme?.secondaryBtn,
    color: serverAppTheme?.btn_font_color,
    height: orderingPortraitOrientation ? '68px' : '44px'
  }), [serverAppTheme]);
  
  
  const myTips = () => {
    return (
       <div className={cn('h-auto ', orderingPortraitOrientation ? (serverAppNavigationMenu?.changeJobType || serverAppNavigationMenu?.changeScreenOrientation) ? 'mt-2 mb-0' : 'my-2' : (serverAppNavigationMenu?.changeJobType || serverAppNavigationMenu?.changeScreenOrientation) ? 'mt-2 pb-0' : 'mt-2 mb-2')}>
          <div className={cn((emptyDeviceGroup || serverAppNavigationMenu?.changeJobType) && 'pb-0')}>
          {(emptyDeviceGroup || serverAppNavigationMenu?.changeJobType) &&
          <TouchableDiv
            role="presentation"
            onClick={() => onChangeJobClick()}
            className={cn('d-flex justify-content-center align-items-center border-0 rounded w-100 text-center', orderingPortraitOrientation ? 'fs_24' : 'fs_20',  isChangeJob && style.selected_btn)}
            style={{background:serverAppTheme?.secondaryBtn, color:serverAppTheme?.btn_font_color, height : orderingPortraitOrientation ? '68px' : '44px'}}
            rippleEffect={true}
          >
            <div className="fw-500 py-2">
              {LABEL().CHANGE_JOB}
            </div>
          </TouchableDiv>}
            {isChangeJob && <div className="mt-2 h-100">
              <SimpleReactSelect ref={dropDownRef} className={cn(style.selecter)} onChange={(data) => { setDefaultValue(data && data.id); setErrors(''); handleChange(data?.id)}} isClearable options={optionForDropdown} name="job" defaultValue={defaultValue} placeholder={LABEL().SELECT_JOB} serverAppTheme={serverAppTheme}/>
              {errors && <div className="text-center fs_10 pt-1" style={{color:serverAppTheme?.error_text}}>{errors}</div>}
            </div>}
          </div>
        {(emptyDeviceGroup || serverAppNavigationMenu?.cashOut) && auth.nonIntegratedPos && <div className='py-0'>
          <TouchableDiv
            role="presentation"
            onClick={() => { handleCashOut(); }}
            className={cn("d-flex fs_20 justify-content-center border-0 rounded w-100 text-center", isOrientationChange && style.selected_btn)}
            style={btnStyle}
            rippleEffect={true}
          >
            <div className={cn("fw-500 py-2 align-self-center", orderingPortraitOrientation ? 'fs_24' : 'fs_20')}>{LABEL().CASH_OUT}</div>
          </TouchableDiv>
        </div>}
        </div>
    );
  };

  const about = () => {
    return (
      <div className={cn('h-auto', orderingPortraitOrientation ? (serverAppNavigationMenu?.changeJobType || serverAppNavigationMenu?.changeScreenOrientation) ? 'pt-0 py-1' : 'pt-0 py-2' : '')}>
         <div className='py-0'>
          <TouchableDiv 
            className={cn("d-flex justify-content-center align-items-center border-0 rounded w-100 text-center")} 
            style={{
              background:serverAppTheme?.secondaryBtn, 
              color:serverAppTheme?.btn_font_color,
              outline: 'none',
              height: orderingPortraitOrientation ? '60px' : '44px'
            }} 
            tabIndex="0" 
            role="button"
            onClick={(e) => { e.preventDefault(); onAboutClick()}}
            rippleEffect={true}
          >
            <div className={cn( "d-flex fs_20 py-2 fw-500 h-100 justify-content-center align-items-center border-0 rounded w-100", orderingPortraitOrientation ? 'fs_24' : 'fs_20')} style={{background:serverAppTheme?.secondaryBtn, color:serverAppTheme?.btn_font_color}}>
              {LABEL().ABOUT}
            </div>
          </TouchableDiv>  
         </div>
      {/* {isAboutShow && <div className={cn(style.card_container, "rounded fs_14")}>
        {aboutFields.map((e) => {
          return (
            <div key={e.key} className="d-flex py-2">
              <div className="col-6 text-left">{e.name}</div>
              <div className="col-6 text-left">{e.prefix} {aboutData.val[e.key]}</div>
            </div>
          );
        })}
      </div>} */}
      <FullWidthModal
        isOpen={isAboutShow}
        isModalCenter
        style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundColor: props.serverAppTheme?.popUp_bg, backgroundClip: 'padding-box', height: '100%' }}
        customClass='h-100 w-100'
        customClass2='h-100 w-100'
        noBackground
      >
          <ModalHeader
            tileHeader={LABEL().ABOUT}
          />
          <div className={cn('col-12 px-3 d-flex justify-content-center align-items-center', !orderingPortraitOrientation ? 'mt-3' : '' )}>
            <div className={cn(style.card_container, "rounded p-3 fs_14", orderingPortraitOrientation ? 'col-12' : 'col-6')}>
              {aboutFields.map((e) => (
                <div key={e.key} className="d-flex py-2">
                  <div className="px-0 col-6 text-left fs_20">{e.name}</div>
                  <div className="px-0 col-6 text-right fw-700 fs_20">
                    {e.prefix} {aboutData.val[e.key]}
                  </div>
                </div>
              ))}
            </div>
          </div>

         <div className={cn("mt-4 col-12 d-flex justify-content-center align-items-center", !orderingPortraitOrientation ? style.closebtn : style.about_close_button)}>
            <TouchableButton
              className={cn("btn-ripple fs_24", orderingPortraitOrientation ? 'btn68' : 'btn44',  style.closebutton)}
              onClick={() => setAboutTipShow(false)}
            >
              {LABEL().ABOUT_CLOSE}
            </TouchableButton>
          </div>

      </FullWidthModal>
      </div> 
    );
  };

  return (
    <>
      {myTips()}
      {about()}
    </>
  );
};

export default React.memo(OptionComp);
